export default "__VITE_ASSET__BCRBgAlA__"